var map = {
	"./add.svg": 4441,
	"./agentBalanceRecordIcon.svg": 7137,
	"./agentBalanceReportIcon.svg": 5964,
	"./arrow.svg": 987,
	"./bet.svg": 1533,
	"./close.svg": 1628,
	"./coin.svg": 4399,
	"./computer.svg": 6275,
	"./dashboard.svg": 940,
	"./disable.svg": 4100,
	"./download.svg": 3000,
	"./editPwd.svg": 581,
	"./enable.svg": 1877,
	"./example.svg": 3602,
	"./exclamationMark.svg": 5804,
	"./eye-open.svg": 8872,
	"./eye.svg": 6071,
	"./form.svg": 5274,
	"./info.svg": 4708,
	"./international.svg": 5748,
	"./ipWhitelistIcon.svg": 5857,
	"./key.svg": 9685,
	"./less.svg": 1083,
	"./link.svg": 344,
	"./lock.svg": 1997,
	"./logout.svg": 5706,
	"./member.svg": 1750,
	"./memberBalanceRecordIcon.svg": 2758,
	"./memberBet.svg": 8899,
	"./memberBetAnalysis.svg": 1157,
	"./menu1.svg": 9190,
	"./menu10.svg": 2618,
	"./menu11.svg": 7883,
	"./menu2.svg": 882,
	"./menu3.svg": 7220,
	"./menu4.svg": 8843,
	"./menu5.svg": 6874,
	"./menu6.svg": 2873,
	"./menu7.svg": 7480,
	"./menu8.svg": 5631,
	"./menu9.svg": 3054,
	"./money.svg": 9740,
	"./more.svg": 1715,
	"./nails.svg": 2543,
	"./nested.svg": 5329,
	"./operationLogIcon.svg": 4872,
	"./password.svg": 6235,
	"./people.svg": 1353,
	"./peoples.svg": 6120,
	"./phone.svg": 3396,
	"./poker.svg": 7415,
	"./post.svg": 6926,
	"./redEnvelope.svg": 1025,
	"./search.svg": 6452,
	"./table.svg": 6524,
	"./thailand.svg": 4665,
	"./top.svg": 2385,
	"./tree.svg": 4784,
	"./treeImg.svg": 3277,
	"./up.svg": 5199,
	"./user.svg": 7273,
	"./winLossReportIcon.svg": 4274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 863;